module.exports = __webpack_public_path__ + "img/5.5de5c6fc.jpg";